import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import {
  DashboardOutlined,
  CodeSandboxOutlined,
  BankOutlined,
  WifiOutlined,
  ApiOutlined,
  GlobalOutlined,
  HddOutlined,
  DatabaseOutlined,
  SecurityScanOutlined,
  TableOutlined,
  BookOutlined,
  KeyOutlined,
  PhoneOutlined,
  LogoutOutlined,
  ClockCircleOutlined,
  FolderOutlined,
  FieldTimeOutlined,
  PauseCircleOutlined,
  BarChartOutlined,
  UsergroupAddOutlined,
  SettingOutlined,
  FileTextOutlined,
  ShoppingOutlined,
  TagsOutlined,
  PercentageOutlined,
  SyncOutlined,
  DollarOutlined,
  CheckSquareOutlined,
  AppstoreOutlined,
  ScheduleOutlined,
} from '@ant-design/icons';
import { accessControls } from 'utils';
import Auth from 'auth';

const NetworkCommanderMenu = ({
  permissions,
  networkSettings,
  defaultSelected,
  defaultOpened,
  menuClickHandle,
}) => {
  return (
    <Menu
      onClick={menuClickHandle}
      theme={networkSettings.navbar_current_mode === 'dark' ? 'dark' : 'light'}
      selectedKeys={[defaultSelected]}
      defaultOpenKeys={defaultOpened}
      mode="inline"
      style={{
        backgroundColor:
          networkSettings.navbar_current_mode === 'dark'
            ? networkSettings.navbar_color_dark_mode
            : networkSettings.navbar_color_light_mode,
      }}
    >
      <Menu.Item
        key="/dashboard"
        icon={<DashboardOutlined style={{ fontSize: '16px' }} />}
      >
        <Link to="/">Dashboard</Link>
      </Menu.Item>

      {(accessControls.can(permissions, 'Client.create:any') ||
        accessControls.can(permissions, 'Client.update:any') ||
        accessControls.can(permissions, 'Client.delete:any')) && (
        <Menu.Item
          key="/clients"
          icon={<HddOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/clients">Resellers</Link>
        </Menu.Item>
      )}

      {accessControls.can(
        permissions,
        'NetworkingToolBranchCustomer.read:any',
      ) && (
        <Menu.Item
          key="/branchcustomer"
          icon={<BankOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/branchcustomer">Clients</Link>
        </Menu.Item>
      )}

      {accessControls.can(permissions, 'NetworkingToolWifiUsers.read:any') && (
        <Menu.Item
          key="/wifiusers"
          icon={<WifiOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/wifiusers">Wireless</Link>
        </Menu.Item>
      )}

      {accessControls.can(
        permissions,
        'NetworkingToolOfficeRegistry.read:any',
      ) && (
        <Menu.Item
          key="/officeregistry"
          icon={<ApiOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/officeregistry">Office Assignment</Link>
        </Menu.Item>
      )}

      {accessControls.can(
        permissions,
        'NetworkingToolPortRegistry.read:any',
      ) && (
        <Menu.Item
          key="/portregistry"
          icon={<ApiOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/portregistry">Switch Port Registry</Link>
        </Menu.Item>
      )}

      {accessControls.can(
        permissions,
        'NetworkingToolMapIpAddressToClient.read:any',
      ) && (
        <Menu.Item
          key="/map_ipaddress_to_client"
          icon={<GlobalOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/map-ip-address-to-client">Public IP List</Link>
        </Menu.Item>
      )}

      {accessControls.can(
        permissions,
        'NetworkingToolMapIpAddressToClient.read:any',
      ) && (
        <Menu.Item
          key="/map-port-to-client"
          icon={<GlobalOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/map-port-to-client">Public Port List</Link>
        </Menu.Item>
      )}

      {accessControls.can(
        permissions,
        'NetworkingToolRackRegistry.read:any',
      ) && (
        <Menu.Item
          key="/rackregistry"
          icon={<CodeSandboxOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/rackregistry">Rack Diagram</Link>
        </Menu.Item>
      )}

      {accessControls.can(permissions, 'NetworkingToolRackDevice.read:any') && (
        <Menu.Item
          key="/rackdevice"
          icon={<HddOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/rackdevice">Rack Device</Link>
        </Menu.Item>
      )}

      {accessControls.can(
        permissions,
        'NetworkingToolDeviceRegistry.read:any',
      ) && (
        <Menu.Item
          key="/deviceregistry"
          icon={<HddOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/deviceregistry">Device Registry</Link>
        </Menu.Item>
      )}

      {/* Login Attempts - Hidden */}
      {/* {accessControls.can(permissions, 'RadDbReports.read:any') && (
        <Menu.Item
          key="/raddb-reports"
          icon={<DatabaseOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/raddb-reports">Login Attempts</Link>
        </Menu.Item>
      )} */}

      {accessControls.can(permissions, 'Isp.read:any') && (
        <Menu.Item
          key="/isp"
          icon={<GlobalOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/isp">ISP Management</Link>
        </Menu.Item>
      )}

      {accessControls.can(permissions, 'UtilityProviders.read:any') && (
        <Menu.Item
          key="/utility-providers"
          icon={<SecurityScanOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/utility-providers">Utility Providers</Link>
        </Menu.Item>
      )}

      {accessControls.can(permissions, 'UtilityProviders.read:any') && (
        <Menu.Item
          key="/service-providers"
          icon={<TableOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/service-providers">Service Providers</Link>
        </Menu.Item>
      )}

      {accessControls.can(
        permissions,
        'NetworkingToolPortRegistry.read:any',
      ) && (
        <Menu.Item
          key="/officenumber"
          icon={<BookOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/officenumber">Office Numbers</Link>
        </Menu.Item>
      )}

      {accessControls.can(permissions, 'ApiKey.read:any') && (
        <Menu.Item
          key="/apikeys"
          icon={<KeyOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/apikeys">API Keys</Link>
        </Menu.Item>
      )}

      {/* Time Tracker - super admin only for now */}
      {accessControls.can(permissions, 'TimeTracker.read:any') && (
        <Menu.SubMenu
          key="/time-tracker"
          icon={<ClockCircleOutlined style={{ fontSize: '16px' }} />}
          title="Time Tracker"
        >
          {accessControls.can(permissions, 'TimeTrackerUserGroup.read:any') && (
            <Menu.Item
              key="/time-tracker/user-groups"
              icon={<UsergroupAddOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/time-tracker/user-groups">User groups</Link>
            </Menu.Item>
          )}
          {(accessControls.can(permissions, 'TimeTrackerProject.update:any') || accessControls.can(permissions, 'TimeTrackerProject.delete:any')) && (
            <Menu.Item
              key="/time-tracker/projects"
              icon={<FolderOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/time-tracker/projects">Projects</Link>
            </Menu.Item>
          )}
          <Menu.Item
            key="/time-tracker/tracker"
            icon={<FieldTimeOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/time-tracker/tracker">Tracker</Link>
          </Menu.Item>
          <Menu.Item
            key="/time-tracker/reports"
            icon={<BarChartOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/time-tracker/reports">Reports</Link>
          </Menu.Item>
          {Number(Auth.getRole()) === 10 && (
            <Menu.Item
              key="/time-tracker/open-timers"
              icon={<PauseCircleOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/time-tracker/open-timers">Open timers</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'Scheduling.read:any') && (
            <Menu.Item
              key="/time-tracker/scheduling"
              icon={<ScheduleOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/time-tracker/scheduling">Schedules</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'Scheduling.update:any') && (
            <Menu.Item
              key="/time-tracker/scheduling/activities"
              icon={<ScheduleOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/time-tracker/scheduling/activities">
                Schedule activities
              </Link>
            </Menu.Item>
          )}
        </Menu.SubMenu>
      )}

      {/* Billing System */}
      {accessControls.can(permissions, 'BillingSystem.read:any') && (
        <Menu.SubMenu
          key="/billing"
          icon={<BankOutlined style={{ fontSize: '16px' }} />}
          title="Billing"
        >
          <Menu.Item
            key="/billing/dashboard"
            icon={<DashboardOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/dashboard">Dashboard</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/invoices"
            icon={<FileTextOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/invoices">Invoices</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/recurring"
            icon={<SyncOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/recurring">Recurring</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/payments"
            icon={<DollarOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/payments">Payments</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/items"
            icon={<ShoppingOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/items">Items (Parts / Services)</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/categories"
            icon={<TagsOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/categories">Categories</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/tax-rates"
            icon={<PercentageOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/tax-rates">Tax Rates</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/settings"
            icon={<SettingOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/settings">Settings</Link>
          </Menu.Item>
        </Menu.SubMenu>
      )}

      {/* Ticket System — Super Admin only */}
      {accessControls.can(permissions, 'TicketSystem.read:any') && (
        <Menu.SubMenu
          key="/tickets"
          icon={<CheckSquareOutlined style={{ fontSize: '16px' }} />}
          title="Tickets"
        >
          <Menu.Item
            key="/tickets/dashboard"
            icon={<DashboardOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/tickets/dashboard">Dashboard</Link>
          </Menu.Item>
          <Menu.Item
            key="/tickets/projects"
            icon={<AppstoreOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/tickets/projects">Projects</Link>
          </Menu.Item>
          <Menu.Item
            key="/tickets/all"
            icon={<FileTextOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/tickets/all">All Tickets</Link>
          </Menu.Item>
        </Menu.SubMenu>
      )}

      {/* Phones Section */}
      {accessControls.can(permissions, 'CallReport.read:any') && (
        <Menu.Item
          key="/call-report"
          icon={<PhoneOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/call-report">Call Report</Link>
        </Menu.Item>
      )}

      {!networkSettings.hide_logout && (
        <Menu.Item
          key="/logout"
          icon={<LogoutOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/logout">Logout</Link>
        </Menu.Item>
      )}
    </Menu>
  );
};

export default NetworkCommanderMenu;
